
  var current='home';
  function goOil(sec){go('oils');setTimeout(function(){var e=document.getElementById(sec);if(e){e.scrollIntoView({behavior:'smooth'})}},80)}
  var DUOPS=[
    {n:'Orange',s:'orange'},{n:'Peppermint',s:'peppermint'},{n:'Lavender',s:'lavender'},{n:'Energy',s:'energy'},
    {n:'Stress Relief',s:'stress'},{n:'Rest Easy',s:'rest-easy'},{n:'Lemon',s:'lemon'},{n:'Lemon-Lime',s:'lemon-lime'},
    {n:'Grapefruit',s:'grapefruit'},{n:'Bergamot',s:'bergamot'},{n:'Lemongrass',s:'lemongrass'},{n:'Eucalyptus',s:'eucalyptus'},
    {n:'Breathe Easy',s:'breathe-easy'},{n:'Coffee',s:'coffee'},{n:'Frankincense',s:'frankincense'},{n:'Immunity',s:'immunity'},
    {n:'Allergy Relief',s:'allergy'},{n:'Nausea Relief',s:'nausea'},{n:'Lavender Mint',s:'lavender-mint'},{n:'Rosemary Mint',s:'rosemary-mint'}];
  var duoPdp={i:0,lid:'White',ring:false};
  function openDuoPdp(i){if(typeof i==='number'){duoPdp.i=i}ensureDpShelf();renderDuoPdp();go('duopdp')}
  function dpToggle(){ensureDpShelf();var s=document.getElementById('dpShelf');if(s){s.hidden=!s.hidden}}
  function dpLid(l){duoPdp.lid=l;
    var wb=document.getElementById('dpLidW'),bb=document.getElementById('dpLidB');
    if(wb){wb.setAttribute('aria-current',l==='White'?'true':'false')}
    if(bb){bb.setAttribute('aria-current',l==='Black'?'true':'false')}
    renderDuoPdp()}
  function renderDuoPdp(){
    var d=DUOPS[duoPdp.i];if(!d)return;dpMark();
    document.getElementById('dpScentName').textContent=d.n;
    var art=(duoPdp.lid==='White'?imSrc('dew-'+d.s):null)||imSrc('de-'+d.s)||imSrc('im-explode')||'';
    /* Oct 21 (Tami): no black-lid set photo for a scent (rosemary mint) fell back to an old white-cap photo; show none instead */
    var real=imSrc('dkb-'+d.s)||(duoPdp.lid==='Black'?null:imSrc('dc-'+d.s));
    var gi=document.getElementById('dpImg');
    gi.src=art;gi.alt='scent and soak duo, exploded view';
    var th=document.getElementById('dpThumbs');
    if(th){
      if(real){
        th.hidden=false;
        th.innerHTML='<button aria-current="true" aria-label="the duo"><img loading="lazy" decoding="async" src="'+art+'" alt=""></button>'+
          '<button aria-current="false" aria-label="'+d.n+' set"><img loading="lazy" decoding="async" src="'+real+'" alt=""></button>';
        var bs=th.querySelectorAll('button');
        bs[0].onclick=function(){gi.src=art;bs[0].setAttribute('aria-current','true');bs[1].setAttribute('aria-current','false')};
        bs[1].onclick=function(){gi.src=real;bs[1].setAttribute('aria-current','true');bs[0].setAttribute('aria-current','false')};
      }else{th.hidden=true;th.innerHTML=''}
    }
    var rt=document.getElementById('dpRingThumb');
    if(rt){var ru=imSrc('sc-'+d.s);if(ru){rt.src=ru}}
    var ring=document.getElementById('dpAddRing');
    duoPdp.ring=!!(ring&&ring.checked);
    var _dp=((typeof esPriceX==='function'&&esPriceX().duo[esPxKey(d.n)])||{})[duoPdp.lid.toLowerCase()]||29.99;
    var total=_dp+(duoPdp.ring?esRingPrice(d.n,'5-pack'):0);
    var cart=document.getElementById('dpCart');
    cart.textContent='add to cart \u00b7 $'+total.toFixed(2);
    cart.onclick=function(){
      quickAdd('scent & soak duo \u00b7 '+d.n+' \u00b7 '+duoPdp.lid.toLowerCase()+' lid',_dp);
      if(duoPdp.ring){quickAdd(d.n+' ring 5-pack',esRingPrice(d.n,'5-pack'))}
    };
  }
  function ensureDpShelf(){
    var shelf=document.getElementById('dpShelf');
    if(!shelf||shelf.childNodes.length)return;
    /* Oct 21 (Tami): A to Z, the list stays open after a pick, and the current scent is highlighted */
    DUOPS.map(function(d,i){return i}).sort(function(a,b){return DUOPS[a].n.localeCompare(DUOPS[b].n)}).forEach(function(i){
      var d=DUOPS[i];
      var b=document.createElement('button');b.className='chip2';b.setAttribute('data-i',i);
      b.innerHTML='<span class="d" style="background:'+((typeof SABG!=='undefined'&&SABG[d.s])||'#999')+'"></span>'+d.n;
      b.onclick=function(){duoPdp.i=i;renderDuoPdp()};
      shelf.appendChild(b);
    });
  }
  function dpMark(){document.querySelectorAll('#dpShelf .chip2[data-i]').forEach(function(c){c.setAttribute('aria-pressed',+c.getAttribute('data-i')===duoPdp.i?'true':'false')})}
  var SABG={'allergy':'#3FC8BE','bergamot':'#E0B741','breathe-easy':'#468BD8','coconut':'#C48D4C','coffee':'#7B5138','energy':'#E4CA35','eucalyptus':'#21BDC9','frankincense':'#DC8663','grapefruit':'#E57977','immunity':'#DF5F32','lavender':'#9C7AD1','lavender-mint':'#7E8BD1','lemon':'#E5D343','lemon-lime':'#C4CF33','lemongrass':'#BEDB64','nausea':'#E58E7B','orange':'#E58932','peppermint':'#248DA3','rest-easy':'#5645B5','rosemary-mint':'#4C7EC4','stress':'#8C58C6'};
  var duoSel={lid:'White'};
  function mobNav(open){var el=document.getElementById('mobNavEl');if(!el)return;el.hidden=!open;
    document.documentElement.style.overflow=open?'hidden':''}
  function clubVote(el){var r=el.parentNode.querySelectorAll('.vote-chip');r.forEach(function(b){b.setAttribute('aria-pressed','false')});el.setAttribute('aria-pressed','true')}
  function duoSelIdx(){var s=document.getElementById('duoScent');var n=s?s.value:'Orange';
    for(var i=0;i<DUOPS.length;i++){if(DUOPS[i].n===n)return i}return 0}
  function duoArtSync(){var d=DUOPS[duoSelIdx()];var img=document.getElementById('duoImg');if(!img||!d)return;
    var w=duoSel.lid==='White'?imSrc('dew-'+d.s):null;
    var u=w||imSrc('de-'+d.s)||imSrc('dc-'+d.s)||imSrc('ob-'+d.s)||imSrc('im-explode');
    if(u){img.src=u}}
  function openDuoPdpSel(){openDuoPdp(duoSelIdx())}
  function duoLid(l){duoSel.lid=l;duoArtSync();
    var wb=document.getElementById('duoLidW'),bb=document.getElementById('duoLidB');
    if(wb){wb.setAttribute('aria-current',l==='White'?'true':'false')}
    if(bb){bb.setAttribute('aria-current',l==='Black'?'true':'false')}}
  function duoAddCart(){
    var s=document.getElementById('duoScent');
    var scent=s?s.value:'Orange';
    quickAdd('scent & soak duo \u00b7 '+scent+' \u00b7 '+duoSel.lid.toLowerCase()+' lid',29.99)}
  function goBd(sec){go('bundles');setTimeout(function(){var e=document.getElementById(sec);if(e){e.scrollIntoView({behavior:'smooth'})}},80)}
  function go(name){
    if(name==='bundle')name='bundles';   /* Oct 14 (#20): build-your-own page retired */
    window.__prevView=typeof current!=='undefined'?current:null;
    if(typeof window.cartDrawer==='function')window.cartDrawer(false);
    document.querySelectorAll('.view').forEach(function(v){v.classList.remove('active')});
    var el=document.getElementById('view-'+name);
    if(el){el.classList.add('active')}
    closeMegas();
    window.scrollTo({top:0,behavior:'instant'});
    current=name;
    var titles={home:'Essence · breathe life',hub:'Essence · shop by mood',pdp:'Essence · scent rings',bundle:'Essence · build your ritual',club:'Essence · essence of the month',kitpdp:'Essence · refresh kits',duopdp:'Essence · scent & soak duo',cart:'Essence · your cart',about:'Essence · our story',gearpdp:'Essence · the hardware',campaign:'Essence · pumpkin spice',candycane:'Essence · Candy Cane, limited holiday edition',logcabin:'Essence · Log Cabin, limited holiday edition',holiday:'Essence · the holiday shop',learn:'Essence · learn',finder:'Essence · find your scent',scents:'Essence · every scent',products:'Essence · shop by product',bundles:'Essence · bundles',subscribe:'Essence · subscribe',oils:'Essence · the oils',oilpdp:'Essence · essential oils'};
    if(titles[name]){document.title=titles[name]}
  }

  function closeMegas(){
    document.querySelectorAll('.mega').forEach(function(m){m.classList.remove('open')});
    document.querySelectorAll('[data-mega]').forEach(function(b){b.setAttribute('aria-expanded','false')});
  }
  document.querySelectorAll('[data-mega]').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.stopPropagation();
      var id='mega-'+btn.getAttribute('data-mega');
      var m=document.getElementById(id);
      var wasOpen=m.classList.contains('open');
      closeMegas();
      if(!wasOpen){m.classList.add('open');btn.setAttribute('aria-expanded','true')}
    });
  });
  document.addEventListener('click',function(e){
    if(!e.target.closest('.mega') && !e.target.closest('[data-mega]')) closeMegas();
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')closeMegas()});

  var toastTimer=null;
  function toast(msg,actLabel,actFn){
    var t=document.getElementById('toast');
    t.innerHTML=msg;
    if(actLabel&&actFn){
      var b=document.createElement('button');
      b.className='toast-act';b.textContent=actLabel;
      b.onclick=function(){actFn();t.classList.remove('show')};
      t.appendChild(b);
    }
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer=setTimeout(function(){t.classList.remove('show')},actLabel?5200:3000);
  }

  /* demo cart with the offer ladder — real line items, floats on every page */
  var cart={items:[]};
  function esSingles(){
    var out=[];
    cart.items.forEach(function(it,i){
      var n=esNorm(it.n);
      if(/ \(subscribed\)$/.test(n))return;
      var m=n.match(/^(.+?) ring single$/)||n.match(/^(.+?) single ring$/);
      if(m)out.push({i:i,scent:esScent(m[1]),p:it.p});
    });
    return out;
  }
  function esPacks(){
    /* Oct 14 (#20): singles no longer auto-combine into 'Pick your mix' packs (they caused 6-ring orders and scent-list
       notes on warehouse slips). Singles check out as singles. */
    return [];
    if(typeof window.__VMAP==='undefined')return [];
    var V=window.__VMAP,s=esSingles(),groups=[],k=0;
    while(s.length-k>=5){groups.push(s.slice(k,k+5));k+=5}
    if(s.length-k>=3){groups.push(s.slice(k,k+3));k+=3}
    return groups.map(function(g){
      var scents=g.map(function(x){return x.scent});
      var uniq=scents.filter(function(v,i,a){return a.indexOf(v)===i});
      var size=g.length,price=size===5?21.99:15.99,vid=null;
      if(uniq.length===1&&typeof esPriceX==='function'&&esPriceX().ring[uniq[0]]&&esPriceX().ring[uniq[0]][size+'-pack']){price=esPriceX().ring[uniq[0]][size+'-pack']}
      var raw=g.reduce(function(t,x){return t+x.p},0);
      if(uniq.length===1&&V.ring[uniq[0]]&&V.ring[uniq[0]][size+'-pack']){vid=V.ring[uniq[0]][size+'-pack']}
      else if(size===5){vid=40812108120227}
      else{
        for(var j=0;j<scents.length;j++){var sc=scents[j];if(sc!=='immunity'&&V.ring[sc]&&V.ring[sc]['3-pack']){vid=V.ring[sc]['3-pack'];break}}
        if(!vid&&V.ring[scents[0]])vid=V.ring[scents[0]]['3-pack'];
      }
      return {idx:g.map(function(x){return x.i}),scents:scents,mixed:uniq.length>1,size:size,price:price,saved:Math.max(0,Math.round((raw-price)*100)/100),vid:vid};
    }).filter(function(p){return p.vid});
  }
  function esCartSavings(){return esPacks().reduce(function(t,p){return t+p.saved},0)}
  function cartTotal(){var raw=cart.items.reduce(function(s,it){return s+it.p},0);return Math.round((raw-esCartSavings())*100)/100}
  function esAfterDisc(t){var r=window.__esDiscR;return (typeof r==='number'&&r>0&&r<1)?Math.round(t*r*100)/100:t}
  function ladderMsg(t){
    if(t<=0){return 'add something and the ladder starts climbing.'}
    if(t<35){return '<b>$'+(35-t).toFixed(2)+' to free shipping</b>'}
    if(window.__GIFTOFF){return 'free shipping ✓'}
    if(t<45){return 'free shipping ✓ · <b>$'+(45-t).toFixed(2)+' to a free scent ring</b>'}
    return 'free shipping ✓ · <b>free scent ring ✓</b>'
  }
  /* Oct 14: the $50 pearl bay gift became a free single ring at $45 (Shopify automatic BXGY 'Free Gift Ring at $45'
     prices the 'Free Gift Ring' product to $0, limit 1, threshold counts everything except the gift). */
  /* Oct 16: free ring OFF for the weekend (Jacob). true = no gift box, no $45 marker, no gift line added, leftover gift lines removed. Set false to bring it back. */
  window.__GIFTOFF=true;try{document.documentElement.classList.add('gift-off')}catch(e){}
  window.__GIFTRING={"eucalyptus":50673139876059,"lemon":50673139908827,"lemon-lime":50673139941595,"orange":50673139974363,"grapefruit":50673140007131,"bergamot":50673140039899,"lemongrass":50673140072667,"immunity":50673140105435,"energy":50673140138203,"coffee":50673140170971,"peppermint":50673140203739,"breathe easy":50673140236507,"allergy relief":50673140269275,"nausea relief":50673140302043,"stress relief":50673140334811,"frankincense":50673140367579,"rosemary mint":50673140400347,"lavender":50673140433115,"lavender mint":50673140465883,"rest easy":50673140498651};
  window.__GIFTORDER=["peppermint", "lavender", "stress relief", "breathe easy", "energy", "nausea relief", "allergy relief", "eucalyptus", "rest easy", "lavender mint", "rosemary mint", "orange", "lemon", "lemon-lime", "grapefruit", "bergamot", "lemongrass", "immunity", "frankincense", "coffee"];
  function esGiftScent(v){
    var G=window.__GIFTRING;
    try{
      if(v&&G[v]){window.__esGiftS=v;localStorage.setItem('esGiftRing',v)}
      var c=window.__esGiftS||localStorage.getItem('esGiftRing');
      return (c&&G[c])?c:'peppermint';
    }catch(e){return (window.__esGiftS&&G[window.__esGiftS])?window.__esGiftS:'peppermint'}
  }
  window.esGiftScent=esGiftScent;
  function esGiftVariant(){return window.__GIFTRING[esGiftScent()]}
  window.esGiftVariant=esGiftVariant;
  function syncCart(){
    var t=cartTotal(), n=cart.items.length, tg=esAfterDisc(t);
    var chip=document.getElementById('cartChip');
    if(chip){chip.textContent='cart · '+n+(n?' · $'+t.toFixed(2):'')}
    var fab=document.getElementById('cartFab');
    if(fab){fab.style.display=n?'block':'none';fab.innerHTML='cart · '+n+' · <b>$'+t.toFixed(2)+'</b>'}
    var lines=document.getElementById('cartLines');
    if(lines){
      lines.innerHTML='';
      if(!n){lines.innerHTML='<div class="cart-empty">nothing yet. the journey starts on the <a href="#" onclick="go(\'home\');return false">homepage</a>.</div>'}
      cart.items.forEach(function(it,i){
        var d=document.createElement('div');
        d.className='cart-line';
        d.innerHTML='<b>'+it.n+'</b><span class="cl-p">$'+it.p.toFixed(2)+'</span>';
        var x=document.createElement('button');
        x.className='cl-x'; x.setAttribute('aria-label','remove '+it.n); x.textContent='✕';
        x.onclick=function(){var removed=cart.items[i];cart.items.splice(i,1);syncCart();toast('removed '+removed.n,'undo',function(){cart.items.splice(i,0,removed);syncCart()})};
        d.appendChild(x);
        var nm=d.querySelector('b');
        if(nm){nm.style.cursor='pointer';nm.setAttribute('role','link');nm.onclick=function(){esCartGo(it.n)}}
        lines.appendChild(d);
      });
    }
    var _pk=esPacks();
    if(lines&&n&&_pk.length){
      var pb=document.createElement('div');pb.className='cart-consol';
      pb.innerHTML='<b>bundled at checkout</b>'+_pk.map(function(p){
        return '<div class="cc-row">'+p.size+' single rings check out as one '+(p.mixed?'mixed ':'')+p.size+'-pack \u00b7 <b>$'+p.price.toFixed(2)+'</b><span class="cc-save">you save $'+p.saved.toFixed(2)+'</span><div class="cc-scents">'+p.scents.join(' \u00b7 ')+'</div></div>';
      }).join('');
      lines.appendChild(pb);
    }
    if(lines&&n&&tg>=45&&!window.__GIFTOFF){
      var gg=document.createElement('div');gg.className='cart-consol cart-gift';
      gg.innerHTML='<b>free ring unlocked</b><div class="cc-row">pick a free scent ring · <b>$0.00</b> at checkout<div style="margin-top:7px"><select class="qa-sel" aria-label="free ring scent" onchange="esGiftScent(this.value);syncCart();window.esRealSync&&esRealSync()">'+window.__GIFTORDER.map(function(k){return '<option value="'+k+'">'+k+'</option>'}).join('')+'</select></div></div>';
      var _gsel=gg.querySelector('select');if(_gsel)_gsel.value=esGiftScent();
      lines.appendChild(gg);
    }
    var lm=document.getElementById('cartLadderMsg');
    if(lm){lm.innerHTML=ladderMsg(tg)+(tg<t&&n?' <span style="opacity:.7">(after sale pricing)</span>':'')}
    var cf=document.getElementById('cartFill');
    if(cf){cf.style.width=Math.min(100,tg/(window.__GIFTOFF?35:45)*100)+'%'}
    var ct=document.getElementById('cartTotal');
    if(ct){ct.textContent='$'+t.toFixed(2)}
    var bump=document.getElementById('cartBump');
    if(bump){
      var hasOil=cart.items.some(function(it){return /oil|kit|bundle|duo|refill/.test(it.n.toLowerCase())});
      bump.hidden=(!n||hasOil);
    }
  }
  function quickAdd(name,price){
    window.__justAdded=Date.now();
    cart.items.push({n:name,p:price});
    syncCart();
    toast('added '+name+'. cart $'+cartTotal().toFixed(2)+' · '+ladderMsg(cartTotal()));
  }


  /* PDP: one page, every scent x every size, owala model */
  var MOODW={sleep:'lights out, actually',relax:'the day, done',focus:'one thing at a time',breathe:'clear runway',refresh:'start again',relief:'back to baseline',custom:'your oil, your ring',seasonal:'here for a good time, not a long time'};
  var TINT={'--sleep':'#D8D3E1','--relax':'#EDE0E9','--focus':'#E2EBD5','--breathe':'#D1E5EA','--refresh':'#F9E4D5','--relief':'#FFDDD9','--ink':'#EFE7DA'};
  /* the real 23-scent catalog, pulled from shopify 2026-08-28. blue rings are colorways, not scents. */
  var SCENTS=[
    {n:'lemon',ing:'100% pure lemon essential oil.',use:'low energy · dull moods · stale rooms',moods:['refresh','focus'],mood:'refresh',c:'--refresh',g:'single',img:'sc-lemon',a:'bright, refreshing lemon for positivity and focus.'},
    {n:'lemon-lime',ing:'100% pure lemon and lime essential oils.',use:'fatigue · foggy focus',moods:['refresh'],mood:'refresh',c:'--refresh',g:'single',img:'sc-lemon-lime',a:'zesty citrus for energy, clarity, and balance.'},
    {n:'orange',ing:'100% certified-organic sweet orange essential oil.',use:'low moods · sluggish mornings',moods:['refresh','focus'],mood:'refresh',c:'--refresh',g:'single',img:'sc-orange',a:'sweet, uplifting orange for positivity and vitality.'},
    {n:'grapefruit',ing:'100% pure pink grapefruit essential oil.',use:'low energy · gloomy days',moods:['refresh'],mood:'refresh',c:'--refresh',g:'single',img:'sc-grapefruit',a:'refreshing, mood-boosting grapefruit for energy and balance.'},
    {n:'bergamot',ing:'100% pure bergamot essential oil.',use:'stress · tension · restless afternoons',moods:['refresh','relax','relief'],mood:'refresh',c:'--refresh',g:'single',img:'sc-bergamot',a:'sunny citrus with an earl-grey ease. lifts the mood, softens stress.'},
    {n:'lemongrass',ing:'100% certified-organic lemongrass essential oil.',use:'stale air · lingering tension',moods:['refresh'],mood:'refresh',c:'--refresh',g:'single',img:'sc-lemongrass',a:'a bright citrus-herbal lift for instant refresh and clarity.'},
    {n:'immunity blend',ing:'a therapeutic-grade blend of eucalyptus, cinnamon bark, lemon, and bergamot essential oils in a fractionated coconut oil base.',use:'seasonal support · travel days · crowded rooms',moods:['refresh'],mood:'refresh',c:'--refresh',g:'blend',img:'sc-immunity',a:'immune-supporting oils for stuffy seasons and crowded rooms.'},
    {n:'energy blend',ing:'a therapeutic-grade blend of peppermint, lime, and sweet orange essential oils in a coconut oil base.',use:'mental fatigue · afternoon slumps · long shifts',moods:['focus'],mood:'focus',c:'--focus',g:'blend',img:'sc-energy',a:'invigorating citrus and peppermint, built for locked-in hours.'},
    {n:'coffee',ing:'pure coffee seed oil in a coconut oil base.',use:'drowsy drives · focus dips',moods:['focus'],mood:'focus',c:'--focus',g:'single',img:'sc-coffee',a:'yes, really. the bold aroma of fresh-brewed coffee, no cup required.'},
    {n:'peppermint',ing:'certified-organic peppermint essential oil in an organic coconut oil base.',use:'headaches · congestion · focus dips',moods:['breathe','focus','relief'],mood:'breathe',c:'--breathe',g:'single',img:'sc-peppermint',a:'cool, refreshing peppermint for energy, relief, and clarity. the night-shift favorite.'},
    {n:'eucalyptus',ing:'100% pure eucalyptus essential oil.',use:'congestion · stuffy sinuses',moods:['breathe','relief'],mood:'breathe',c:'--breathe',g:'single',img:'sc-eucalyptus',a:'pure eucalyptus for refreshing relief. shower-steam in ring form.'},
    {n:'breathe easy blend',ing:'a therapeutic-grade blend of eucalyptus, laurel leaf, ravintsara, peppermint, lemon, and tea tree essential oils.',use:'congestion · seasonal stuffiness',moods:['breathe','sleep'],mood:'breathe',c:'--breathe',g:'blend',img:'sc-breathe-easy',a:'refreshing oils blended for open airways and clarity.'},
    {n:'allergy relief',ing:'a therapeutic-grade blend of peppermint, basil, lemon, and eucalyptus essential oils in a coconut oil base.',use:'sinus pressure · seasonal sniffles',moods:['breathe'],mood:'breathe',c:'--breathe',g:'blend',img:'sc-allergy',a:'designed to ease congestion and open your airways through heavy seasons.'},
    {n:'nausea relief blend',ing:'a therapeutic-grade blend of peppermint, spearmint, ginger, cardamom, and fennel essential oils.',use:'queasy stomachs · motion sickness · morning sickness',moods:['relief'],mood:'relief',c:'--relief',g:'blend',img:'sc-nausea',a:'the settling blend for rough stomachs, long drives, and first trimesters.'},
    {n:'stress relief blend',ing:'a 13-oil therapeutic-grade blend: copaiba, sweet orange, lime, ho wood, lavender, sweet marjoram, ylang ylang, sandalwood, roman chamomile, peru balsam, black spruce, frankincense, and blue tansy.',use:'tension · racing thoughts · long days',moods:['relax','relief','sleep'],mood:'relax',c:'--relax',g:'blend',img:'sc-stress',a:'calming oils to relax, restore, and recharge.'},
    
    {n:'frankincense',ing:'100% certified-organic frankincense essential oil.',use:'racing minds · shallow breathing',moods:['relax','relief'],mood:'relax',c:'--relax',g:'single',img:'sc-frankincense',a:'grounding, soothing resin calm. instant quiet.'},
    {n:'rosemary mint',ing:'certified-organic rosemary and peppermint essential oils in an organic coconut oil base.',use:'mental fog · focus dips',moods:['relax','focus','breathe'],mood:'relax',c:'--relax',g:'blend',img:'sc-rosemary-mint',a:'invigorating clarity. awakens the senses, sharpens focus.'},
    {n:'lavender',ing:'100% pure lavender essential oil.',use:'restlessness · tension · trouble winding down',moods:['sleep','relax'],mood:'sleep',c:'--sleep',g:'single',img:'sc-lavender',a:'soothing lavender for relaxation, balance, and sleep support. the classic, for a reason.'},
    {n:'lavender mint',ing:'certified-organic lavender and peppermint essential oils in an organic coconut oil base.',use:'tension headaches · stress',moods:['sleep','focus'],mood:'sleep',c:'--sleep',g:'blend',img:'sc-lavender-mint',a:'lavender kept fresh by mint. calms the mind, eases tension.'},
    {n:'rest easy blend',ing:'a therapeutic-grade blend of himalayan cedarwood, ho wood, sweet orange, roman chamomile, and vetiver essential oils.',use:'trouble falling asleep · restless nights',moods:['sleep'],mood:'sleep',c:'--sleep',g:'blend',img:'sc-rest-easy',a:'the house bedtime blend: lavender-forward with a soft woody base, built to relax the mind.'},
    {n:'create it',ing:'unscented medical-grade silicone, ready for your own oils.',use:'your own experiments',moods:['custom'],mood:'custom',c:'--ink',g:'single',img:'sc-create-it',a:'the unscented ring, your canvas. add any 5 mL oil and make it yours.'},
    {n:'pumpkin spice',ing:'a seasonal blend of warm spice and citrus essential oils.',use:'sweater weather · cozy cravings',moods:['seasonal'],mood:'seasonal',c:'--refresh',g:'seasonal',img:'sc-pumpkin',a:'limited fall edition. here until october 1, then it retires to the vault.'}
  ];
  var PACKS=[
    {label:'single',price:7.99},
    {label:'3-pack',price:15.99},
    {label:'5-pack',price:21.99},
    {label:'10-pack',price:39.99}
  ];
  var pdp={scent:20,pack:2,deliv:'one'};
  var INK_MOODS={};
  var DEEP={'--sleep':'#3A2568','--relax':'#7E3E68','--focus':'#5C7C24','--breathe':'#145E72','--refresh':'#B35714','--relief':'#BC2438','--ink':'#17121F'};
  /* per-scent colors, DRAFT (meeting 2026-09-03: dot = the scent's own color, not the mood) — needs Tami/Judah pass + contrast checks */
  var SEDGE={"sc-allergy": "linear-gradient(180deg,#4CBEB6 0%,#83D8D1 100%)", "sc-bergamot": "linear-gradient(180deg,#D6AE4F 0%,#E8CE84 100%)", "sc-breathe-easy": "linear-gradient(180deg,#5287CD 0%,#88B4E5 100%)", "sc-coconut": "linear-gradient(180deg,#D4AF6B 0%,#E5CE9A 100%)", "sc-coffee": "linear-gradient(180deg,#7A5B47 0%,#A88E7F 100%)", "sc-create-it": "linear-gradient(180deg,#C6C3BA 0%,#DCDBD6 100%)", "sc-energy": "linear-gradient(180deg,#DAC047 0%,#EAD97D 100%)", "sc-eucalyptus": "linear-gradient(180deg,#3AB3BE 0%,#75D2D9 100%)", "sc-frankincense": "linear-gradient(180deg,#D28569 0%,#E5B199 100%)", "sc-grapefruit": "linear-gradient(180deg,#D97A78 0%,#EAA9A7 100%)", "sc-immunity": "linear-gradient(180deg,#D46547 0%,#E8977C 100%)", "sc-lavender": "linear-gradient(180deg,#967AC7 0%,#C0A9E1 100%)", "sc-lavender-mint": "linear-gradient(180deg,#7E88C6 0%,#ADB5E3 100%)", "sc-lemon": "linear-gradient(180deg,#D9C950 0%,#EADF85 100%)", "sc-lemon-lime": "linear-gradient(180deg,#B8C446 0%,#D5DC7C 100%)", "sc-lemongrass": "linear-gradient(180deg,#B5D16A 0%,#D4E499 100%)", "sc-nausea": "linear-gradient(180deg,#DA8B7C 0%,#EBB7A9 100%)", "sc-orange": "linear-gradient(180deg,#DA8745 0%,#EBB47C 100%)", "sc-peppermint": "linear-gradient(180deg,#3B899D 0%,#76B5C4 100%)", "sc-rest-easy": "linear-gradient(180deg,#5D52AE 0%,#9188CB 100%)", "sc-rosemary-mint": "linear-gradient(180deg,#6CA0D0 0%,#9EC5E4 100%)", "sc-stress": "linear-gradient(180deg,#885FBB 0%,#B692DA 100%)", "sc-pumpkin": "#A95613"};
  var SCOL={'lemon':'#F2C531','lemon-lime':'#B7CE3B','orange':'#E0792D','grapefruit':'#F0728F','bergamot':'#E9A83C','lemongrass':'#A8C15A','immunity blend':'#D9822B','energy blend':'#8FB33A','coffee':'#6B4A2F','peppermint':'#2FA3A9','eucalyptus':'#4E9B8F','breathe easy blend':'#1B7D97','allergy relief':'#7FB6C9','nausea relief blend':'#FF7A5C','stress relief blend':'#9C6FB0','coconut calm':'#C9A87C','frankincense':'#8A6E4B','rosemary mint':'#5E8F6E','lavender':'#9A7DC9','lavender mint':'#7D8FC9','rest easy blend':'#6B5CA8','create it':'#C9C4BC','pumpkin spice':'#C46A2B'};
  function toggleScents(){
    var sh=document.getElementById('selShelf');
    var b=document.getElementById('discoverBtn');
    sh.hidden=!sh.hidden;
    b.textContent=sh.hidden?'discover more scents ▾':'fewer scents ▴';
  }
  function ingAdd(btn,name){
    var sel=btn.parentElement.querySelector('select');
    var o=sel.selectedOptions[0];
    quickAdd(name+' '+o.textContent.split('·')[0].trim(),parseFloat(o.getAttribute('data-p')));
  }
  (function(){
    var shelf=document.getElementById('selShelf');
    if(!shelf)return;
    SCENTS.forEach(function(s,i){
      var b=document.createElement('button');
      b.className='chip2';
      b.setAttribute('data-si',i);
      b.setAttribute('data-kind','chip');
      b.setAttribute('title',s.g==='seasonal'?'seasonal':s.mood);
      b.innerHTML='<span class="d" style="background:'+(SCOL[s.n]||'#999999')+'"></span>'+s.n;
      b.onclick=function(){pickScent(i)};
      shelf.appendChild(b);
    });
    var pr=document.getElementById('packRow');
    if(pr){pr.querySelectorAll('.pack').forEach(function(p){p.onclick=function(){pdp.pack=+p.getAttribute('data-pack');renderPdp()}})}
    var dr=document.getElementById('delivRow');
    if(dr){dr.querySelectorAll('.sub-row').forEach(function(d){d.onclick=function(){pdp.deliv=d.getAttribute('data-deliv');renderPdp()}})}
    renderPdp();
  })();
  function pickScent(i){pdp.scent=i;renderPdp()}
  function updateSel(){
    document.querySelectorAll('[data-si]').forEach(function(b){
      var i=+b.getAttribute('data-si');
      var sel=(i===pdp.scent);
      b.setAttribute('aria-current',sel?'true':'false');
      if(b.getAttribute('data-kind')==='chip'){
        if(sel){
          b.style.background='var(--ink)';
          b.style.color='var(--cream)';
          b.style.borderColor='var(--ink)';
        }else{
          b.style.background='var(--white)';
          b.style.color='var(--ink)';
          b.style.borderColor='var(--line)';
        }
      }
    });
  }
  function esPxKey(n){n=(''+n).toLowerCase().replace(/^sweet /,'').replace(/ blend$/,'');if(n==='nausea')n='nausea relief';return n}
  function esPriceX(){
    return window.__PRICEX||(window.__PRICEX={
      ring:{'immunity':{'single':5.99,'3-pack':13.99,'5-pack':18.99},'create it':{'single':7.49,'3-pack':14.99}},
      oil:{'immunity':10.99,'energy':11.99,'frankincense':15.99,'pumpkin spice':16.99},
      duo:{'immunity':{black:27.99,white:27.99},'stress relief':{white:26.99}}
    });
  }
  function esRingPrice(scentName,label){
    var ov=esPriceX().ring[esPxKey(scentName)];
    if(ov&&ov[label])return ov[label];
    var idx={'single':0,'3-pack':1,'5-pack':2,'10-pack':3}[label];
    return PACKS[idx].price;
  }
  function esOilPrice(scentName){return esPriceX().oil[esPxKey(scentName)]||14.99}
  function pdpPrice(){
    var base=esRingPrice(SCENTS[pdp.scent].n,PACKS[pdp.pack].label);
    if(pdp.deliv==='sub'){base=base*0.9}
    var oil=document.getElementById('addOil');
    var bay=document.getElementById('addBay');
    if(oil&&oil.checked){base+=12.99}
    if(bay&&bay.checked){base+=9.99}
    return base;
  }
  function renderPdp(){
    var s=SCENTS[pdp.scent];
    updateSel();
    var _fmts=['single','3-pack','5-pack','10-pack'];
    var _rv=(window.__VMAP&&window.__VMAP.ring&&window.__VMAP.ring[esScent(s.n)])||{};
    document.querySelectorAll('#packRow .pack').forEach(function(pb){
      var f=_fmts[+pb.getAttribute('data-pack')];
      pb.style.display=_rv[f]?'':'none';
      var _pp=esRingPrice(s.n,f);
      for(var ci=0;ci<pb.childNodes.length;ci++){var nd=pb.childNodes[ci];if(nd.nodeType===3&&/\$/.test(nd.nodeValue)){nd.nodeValue='$'+_pp.toFixed(2);break}}
      var _per=pb.querySelector('.per');
      if(_per){_per.textContent='$'+(_pp/({'single':1,'3-pack':3,'5-pack':5,'10-pack':10}[f])).toFixed(2)+' / ring'}
    });
    if(!_rv[_fmts[pdp.pack]])pdp.pack=2;
    document.getElementById('scentName').textContent=s.n;
    var cm=document.getElementById('pdpCrumbMood');
    if(cm){cm.textContent=s.mood;cm.onclick=function(){if(typeof MOODS!=='undefined'&&MOODS[s.mood]){goHub(s.mood)}else{go('home')}return false}}
    var cn=document.getElementById('pdpCrumbName');
    if(cn){cn.textContent=s.n}
    document.getElementById('pdpTitle').textContent=s.n;
    document.getElementById('pdpWhisper').textContent=s.w||MOODW[s.mood];
    var about=s.a||('part of the '+s.mood+' shelf.');
    document.getElementById('scentAbout').innerHTML='<span class="serif">'+about+'</span>'
      +(s.use?'<div class="pdp-use"><b>often used for</b> \u2014 '+s.use+'</div>':'')
      +(s.ing?'<div class="pdp-ing"><b>ingredients</b> \u2014 '+s.ing+(s.n==='create it'?'':' the ring itself is medical-grade silicone with a fractionated coconut oil carrier.')+'</div>':'');
    var chip=document.getElementById('pdpMood');
    chip.textContent=s.mood;
    chip.style.background='var('+s.c+')';
    chip.style.color=INK_MOODS[s.c]?'var(--ink)':'var(--cream)';
    var gi=document.getElementById('galleryImg');
    var src=document.getElementById(s.img);
    if(src){gi.src=src.src}
    var stage=document.getElementById('galleryStage');
    if(s.img.indexOf('sc-')===0){stage.classList.add('gal-full');gi.style.width='100%'}
    else{stage.classList.remove('gal-full');gi.style.width=(s.img==='ph-ring')?'52%':'82%'}
    gi.alt=s.n+' scent ring';
    var th=document.getElementById('galThumbs');
    if(th){
      var slug=s.img.slice(3);
      var saU=imSrc('sa-'+slug);
      var ringU=src?src.src:'';
      if(saU&&ringU){
        th.hidden=false;
        var heldU=imSrc('im-heldring');
        th.innerHTML='<button aria-current="true" aria-label="interactive 3D view" class="th-3d">360&deg;</button>'
          +(heldU?'<button aria-current="false" aria-label="held in hand"><img loading="lazy" decoding="async" src="'+heldU+'" alt=""></button>':'')
          +(saU?'<button aria-current="false" aria-label="sealed sachet"><img loading="lazy" decoding="async" src="'+saU+'" alt=""></button>':'');
        var galSrcs=[null].concat(heldU?[heldU]:[]).concat(saU?[saU]:[]);
        var bs=th.querySelectorAll('button');
        var mvOK=!!(window.customElements&&customElements.get('model-viewer'));
        if(!mvOK&&bs.length){bs[0].style.display='none';
          if(window.customElements&&customElements.whenDefined){customElements.whenDefined('model-viewer').then(function(){if(bs[0])bs[0].style.display=''}).catch(function(){})}}
        var mv=document.getElementById('galleryMv');
        function pick(i){
          bs.forEach(function(b,k){b.setAttribute('aria-current',k===i?'true':'false')});
          if(i===0&&mv){gi.style.display='none';mv.hidden=false;mv.style.display='block';
            mv.setAttribute('poster',ringU);
            var glb=window.__ES_A["essence-ring-v2.glb"];
            if(mv.getAttribute('data-glb')!==glb){mv.setAttribute('data-glb',glb);mv.src=glb}
            var col=SABG[slug]||SCOL[s.n]||'#EAD9C5';mv.style.background='linear-gradient(175deg,'+col+' 0%,'+col+' 55%,rgba(23,18,31,.18) 160%),'+col;
            if(!mv.getAttribute('data-errwired')){mv.setAttribute('data-errwired','1');
              mv.addEventListener('error',function(){mv.hidden=true;mv.style.display='none';gi.style.display='';gi.src=ringU})}}
          else{if(mv){mv.hidden=true;mv.style.display='none'}gi.style.display='';gi.src=galSrcs[i]||saU||ringU}
        }
        bs.forEach(function(b,i){b.onclick=function(){pick(i)}});
        pick(mvOK?0:(bs.length>1?1:0));
      }else{th.hidden=true;th.innerHTML='';var mv2=document.getElementById('galleryMv');if(mv2){mv2.hidden=true;mv2.style.display='none'}var gi2=document.getElementById('galleryImg');if(gi2){gi2.style.display=''}}
    }
    var bo=document.getElementById('bumpOilImg');
    if(bo){var ou=imSrc('ob-'+s.img.slice(3));if(ou){bo.src=ou}}
    var rb=document.getElementById('rbBayThumb');
    if(rb){rb.src=imSrc('ib-'+s.img.slice(3))||imSrc('im-bay')||rb.src}
    document.querySelectorAll('#packRow .pack').forEach(function(p){p.setAttribute('aria-current',+p.getAttribute('data-pack')===pdp.pack?'true':'false')});
    var base=esRingPrice(SCENTS[pdp.scent].n,PACKS[pdp.pack].label);
    document.getElementById('onePrice').textContent='$'+base.toFixed(2);
    document.getElementById('subPrice').textContent='$'+(base*0.9).toFixed(2)+' · save 10%';
    document.querySelectorAll('#delivRow .sub-row').forEach(function(d){d.setAttribute('aria-current',d.getAttribute('data-deliv')===pdp.deliv?'true':'false')});
    document.getElementById('pdpCartBtn').textContent='add to cart · $'+pdpPrice().toFixed(2);
  }
  function pdpAddToCart(){
    var s=SCENTS[pdp.scent];
    quickAdd(s.n+' ring '+PACKS[pdp.pack].label+(pdp.deliv==='sub'?' (subscribed)':''),pdpPrice());
    cartDrawer(true);
  }

  /* bundle builder */
  var bb={items:[],total:0};
  function bbRemove(i){bb.items.splice(i,1);bbRender()}
  function bbAddFixed(name,price){bb.items.push({name:name,price:price});bbRender()}
  function bbAdd(name,price,btn){
    var scent=btn.parentElement.querySelector('select').value;
    bb.items.push({name:scent+' '+name,price:price});
    bbRender();
  }
  function bbRender(){
    var list=document.getElementById('bbList');
    list.innerHTML='';
    var sub=0;
    bb.items.forEach(function(it,idx){
      sub+=it.price;
      var li=document.createElement('li');
      li.innerHTML='<span>'+it.name+'</span><span>$'+it.price.toFixed(2)+' <button class="bb-x" aria-label="remove '+it.name+'" onclick="bbRemove('+idx+')">\u00d7</button></span>';
      list.appendChild(li);
    });
    if(!bb.items.length){list.innerHTML='<li class="bb-empty">nothing yet. add three items and save 10%, five and save 15%.</li>'}
    var disc=bb.items.length>=5?.15:(bb.items.length>=3?.10:0);
    var total=sub*(1-disc);
    bb.total=total;
    document.getElementById('bbTotal').textContent='$'+total.toFixed(2);
    document.getElementById('bbDiscount').textContent=disc?('bundle discount ✓ save '+(disc*100)+'%'):(bb.items.length?('add '+(3-bb.items.length)+' more to save 10%'):'');
    document.getElementById('bbFill').style.width=Math.min(100,total/60*100)+'%';
  }
  function bbCheckout(){
    if(!bb.items.length){toast('add something first');return}
    bb.items.forEach(function(it){cart.items.push({n:it.name,p:it.price})});syncCart();cartDrawer(true);toast('added '+bb.items.length+' items to your cart');
    bb.items=[];bbRender();
  }



  /* ============ the hub engine: one template, six moods ============ */
  var ARC=['refresh','focus','breathe','relief','relax','sleep'];
  var MOODS={
    refresh:{c:'--refresh',ink:true,sub:'start again. bright citrus for mornings, resets, and rooms that need opening.',art:'bh-refresh',routine:{name:'the fresh start kit',head:'the morning, handled before the kettle boils.',items:[['2 citrus rings','sc-orange'],['sweet orange oil 5 mL','ob-orange'],['pearl soaking bay','im-bay']]}},
    focus:{c:'--focus',ink:true,sub:'one thing at a time. the scents that keep the tab count in your head at one.',art:'bh-focus',routine:{name:'the deep work kit',head:'everything a long morning of real work asks for.',items:[['2 energy rings','sc-energy'],['energy oil 5 mL','ob-energy'],['pearl soaking bay','im-bay']]}},
    breathe:{c:'--breathe',ink:false,sub:'clear runway. cool mint and eucalyptus for airways, shifts, and stuffy seasons.',art:'bh-breathe',routine:{name:'the shift kit',head:'twelve hours goes by easier. ask any nurse we know.',items:[['2 respiratory rings','sc-breathe-easy'],['peppermint oil 5 mL','ob-peppermint'],['pearl soaking bay','im-bay']]}},
    relief:{c:'--relief',ink:true,sub:'back to baseline. settling blends for rough stomachs, long drives, and loud days.',art:'bh-relief',routine:{name:'the rough day kit',head:'for when it hits. and it does hit.',items:[['2 nausea relief rings','sc-nausea'],['nausea relief oil 5 mL','ob-nausea'],['pearl soaking bay','im-bay']]}},
    relax:{c:'--relax',ink:false,sub:'the day, done. warm, soft scents for the hour that belongs to you.',art:'bh-relax',routine:{name:'the wind-down kit',head:'the evening ritual, boxed.',items:[['2 stress relief rings','sc-stress'],['stress relief oil 5 mL','ob-stress'],['pearl soaking bay','im-bay']]}},
    sleep:{c:'--sleep',ink:false,sub:'lights out, actually. a lavender-led shelf you wear under your nose and breathe all night, no pills, no podcasts, no counting anything.',art:'bh-sleep',routine:{name:'the sleep routine',head:'everything a bad sleeper needs. nothing they don\'t.',items:[['2 rest easy rings','sc-rest-easy'],['rest easy oil 5 mL','ob-rest-easy'],['pearl soaking bay','im-bay']]}}
  };
  var currentHub='sleep';
  function imSrc(id){var el=document.querySelector('[data-im="'+id+'"]')||document.getElementById(id);return el?el.src:null}
  function openScentPdp(i){pickScent(i);go('pdp')}
  function goFinder(){fxReset();go('finder')}

  /* learn: scent library grid */
  (function(){var g=document.getElementById('libGrid');if(!g)return;
  SCENTS.forEach(function(s,i){var col=SCOL[s.n]||'#999';var c=parseInt(col.slice(1),16);
  var lum=0.2126*(c>>16&255)+0.7152*(c>>8&255)+0.0722*(c&255);
  var b=document.createElement('button');b.className='lib-tile';b.style.background=col;
  b.style.color='var(--cream)';
  b.innerHTML='<b>'+s.n+'</b><span>'+s.mood+'</span>';
  b.onclick=function(){openScentPdp(i)};g.appendChild(b)});})();
  /* the scent finder */
  /* the scent finder: 8-question weighted quiz */
  var QZ=[
   {q:'1 \u00b7 What are you here to fix?',o:[
    {t:'mornings are rough',d:'slow starts, groggy resets',m:{refresh:3}},
    {t:'my focus is shot',d:'forty tabs, none finished',m:{focus:3}},
    {t:'stuffy airways',d:'blocked nose, heavy seasons',m:{breathe:3}},
    {t:'a rebellious stomach',d:'travel, waves, rough days',m:{relief:3}},
    {t:'i cannot switch off',d:'evenings that stay wired',m:{relax:3}},
    {t:'sleep is broken',d:'lights out, brain on',m:{sleep:3}}]},
   {q:'2 \u00b7 When would you actually wear it?',o:[
    {t:'first thing in the morning',m:{refresh:2,focus:1}},
    {t:'through the work hours',m:{focus:2}},
    {t:'on long shifts',d:'nurses, we see you',m:{breathe:2,focus:1}},
    {t:'travel days',m:{relief:2}},
    {t:'the evening wind-down',m:{relax:2}},
    {t:'all night',m:{sleep:3}}]},
   {q:'3 \u00b7 Pick a scent family. gut answer.',o:[
    {t:'bright and citrusy',s:{0:2,1:2,2:2,3:2,4:2},m:{refresh:1}},
    {t:'cool and minty',s:{9:3,11:2,19:1},m:{breathe:1}},
    {t:'green and herbal',s:{17:3,5:2,10:1},m:{focus:1}},
    {t:'soft and floral',s:{18:3,20:2,19:1},m:{sleep:1}},
    {t:'warm and woody',s:{16:3,6:1},m:{relax:1}},
    {t:'creamy and sweet',s:{15:3},m:{relax:1}}]},
   {q:'4 \u00b7 How loud should a scent be?',o:[
    {t:'a whisper',d:'only I should know it is there',s:{18:1,4:1,15:1}},
    {t:'clearly there',d:'the sweet spot'},
    {t:'full send',d:'blends, layers, the works',s:{7:1,11:1,14:1,6:1,13:1,20:1}}]},
   {q:'5 \u00b7 Real talk: lavender?',o:[
    {t:'the classic. love it.',s:{18:3,20:1},m:{sleep:1}},
    {t:'like it with a twist',d:'fresher, less sweet',s:{19:3}},
    {t:'not my thing',x:[18,19,20]}]},
   {q:'6 \u00b7 Your week, in one word:',o:[
    {t:'chaos',s:{14:2},m:{relax:1}},
    {t:'the grind',s:{7:2,8:1},m:{focus:1}},
    {t:'stuffy',s:{12:2,10:1},m:{breathe:1}},
    {t:'queasy',s:{13:3},m:{relief:1}},
    {t:'wired',s:{14:2,20:1}},
    {t:'running on empty',s:{7:2},m:{refresh:1}}]},
   {q:'7 \u00b7 Coffee. thoughts?',o:[
    {t:'it is a personality trait',s:{8:4},m:{focus:1}},
    {t:'smells great, tastes better',s:{8:2}},
    {t:'keep it away from me',x:[8]}]},
   {q:'8 \u00b7 Where will the ring live?',o:[
    {t:'on my nightstand',m:{sleep:1}},
    {t:'in my bag',m:{relief:1}},
    {t:'at my desk',m:{focus:1}},
    {t:'in the gym bag',s:{7:1},m:{breathe:1}},
    {t:'kitchen windowsill',m:{refresh:1}}]}
  ];
  var qzI=0, qzPicks=[];
  function qzRender(){
    var q=QZ[qzI];
    document.getElementById('qzCount').textContent='question '+(qzI+1)+' of '+QZ.length;
    document.getElementById('qzFill').style.width=((qzI)/QZ.length*100)+'%';
    document.getElementById('qzQ').textContent=q.q;
    var o=document.getElementById('qzOpts');o.innerHTML='';
    q.o.forEach(function(op,oi){
      var b=document.createElement('button');b.className='fx-opt';
      b.innerHTML='<b>'+op.t+'</b>'+(op.d||'');
      b.onclick=function(){qzPicks[qzI]=oi;qzI++;if(qzI>=QZ.length){qzScore()}else{qzRender()}};
      o.appendChild(b);
    });
    document.getElementById('qzBackBtn').hidden=(qzI===0);
  }
  function qzBack(){if(qzI>0){qzI--;qzPicks.length=qzI;qzRender()}}
  function qzScore(){
    var mood={refresh:0,focus:0,breathe:0,relief:0,relax:0,sleep:0};
    var pts={}, excl={21:1,22:1};
    qzPicks.forEach(function(oi,qi){
      var op=QZ[qi].o[oi];if(!op)return;
      if(op.m){for(var k in op.m){mood[k]+=op.m[k]}}
      if(op.s){for(var k2 in op.s){pts[k2]=(pts[k2]||0)+op.s[k2]}}
      if(op.x){op.x.forEach(function(i2){excl[i2]=1})}
    });
    var best=-1,bestScore=-1e9,second=-1,secondScore=-1e9;
    SCENTS.forEach(function(s,i){
      if(excl[i])return;
      var mBest=0;(s.moods||[s.mood]).forEach(function(m2){if((mood[m2]||0)>mBest)mBest=mood[m2]});
      var sc=(pts[i]||0)+mBest*0.6;
      if(sc>bestScore){second=best;secondScore=bestScore;best=i;bestScore=sc}
      else if(sc>secondScore){second=i;secondScore=sc}
    });
    document.getElementById('fxQuiz').hidden=true;
    qzShow(best, second);
  }
  function qzShow(i, ri){
    var s=SCENTS[i];
    document.getElementById('fxImg').src=imSrc(s.img)||'';
    document.getElementById('fxName').textContent=s.n;
    var CHEEK={refresh:'morning person energy, even if you have to fake it.',focus:'forty tabs, one nose. you\'ve got this.',breathe:'big lung energy. inhale like you mean it.',relief:'your stomach called. it says thank you.',relax:'the evening is yours again. defend it.',sleep:'lights out, actually. we mean it.',custom:'your rules. your oil. your ring.',seasonal:'here for a good time, not a long time.'};
    document.getElementById('fxCheek').textContent=CHEEK[s.mood]||'';
    document.getElementById('fxWhisper').textContent=s.w||MOODW[s.mood]||'';
    document.getElementById('fxAbout').textContent=s.a||('part of the '+s.mood+' shelf.');
    var pill=document.getElementById('fxMoodPill');pill.textContent=s.mood;
    pill.style.background='var('+s.c+')';pill.style.color='var(--cream)';
    document.getElementById('fxAdd').textContent='add the 5-pack \u00b7 $21.99';
    document.getElementById('fxAdd').onclick=function(){quickAdd(s.n+' ring 5-pack',21.99)};
    document.getElementById('fxPdp').onclick=function(){openScentPdp(i)};
    var hb=document.getElementById('fxHub');
    if(MOODS[s.mood]){hb.style.display='';hb.textContent='browse the '+s.mood+' shelf';hb.onclick=function(){goHub(s.mood)}}else{hb.style.display='none'}
    var r=document.getElementById('fxRunner');
    if(ri>=0){r.parentElement.style.display='';r.textContent=SCENTS[ri].n;r.onclick=function(){openScentPdp(ri);return false}}
    else{r.parentElement.style.display='none'}
    document.getElementById('fxStep3').hidden=false;
  }
  function fxReset(){qzI=0;qzPicks=[];document.getElementById('fxStep3').hidden=true;document.getElementById('fxQuiz').hidden=false;qzRender()}
  
  var oilPdp={scent:18,deliv:'one'};
  function opToggle(){
    var sh=document.getElementById('opShelf');
    var b=document.getElementById('opDiscoverBtn');
    sh.hidden=!sh.hidden;
    b.innerHTML=sh.hidden?'discover more oils &#9662;':'fewer oils &#9652;';
  }
  var KITSP=[
    {m:'refresh',n:'the fresh start kit',ring:'2 citrus rings',rimg:'sc-orange',oil:'Sweet Orange oil',oimg:'ob-orange',a:'two citrus rings, one to wear and one riding inside the bay, plus the orange oil that refills them. mornings, handled.'},
    {m:'focus',n:'the deep work kit',ring:'2 energy rings',rimg:'sc-energy',oil:'Energy Blend oil',oimg:'ob-energy',a:'energy rings for the long stretch, the blend to keep them going, and the soak between sessions.'},
    {m:'relief',n:'the rough day kit',ring:'2 nausea relief rings',rimg:'sc-nausea',oil:'Nausea Relief oil',oimg:'ob-nausea',a:'for the days that fight back. nausea relief rings, the oil to refresh them, and the bay for overnight resets.'},
    {m:'breathe',n:'the shift kit',ring:'2 respiratory rings',rimg:'sc-breathe-easy',oil:'Peppermint oil',oimg:'ob-peppermint',a:'clear-airway rings for the whole shift, peppermint to recharge them, and the soak that makes one ring last.'},
    {m:'relax',n:'the wind-down kit',ring:'2 stress relief rings',rimg:'sc-stress',oil:'Stress Relief oil',oimg:'ob-stress',a:'the day, done. stress relief rings, the oil to top them up, and the bay for the evening ritual.'},
    {m:'sleep',n:'the sleep routine',ring:'2 rest easy rings',rimg:'sc-rest-easy',oil:'Rest Easy oil',oimg:'ob-rest-easy',a:'lights out, actually. rest easy rings, the oil that refills them, and the soak that resets them for tomorrow.'}];
  var KITSP_ORDER=[0,1,3,2,4,5];
  var kitPdp={i:0};
  function openKitPdp(i){kitPdp.i=i;renderKitPdp();go('kitpdp')}
  function kpToggle(){var s=document.getElementById('kpShelf');if(s){s.hidden=!s.hidden}}
  function renderKitPdp(){
    var k=KITSP[kitPdp.i];if(!k)return;
    document.getElementById('kpCrumb').textContent=k.n;
    document.getElementById('kpTitle').textContent=k.n;
    document.getElementById('kpKitName').textContent=k.n;
    var chip=document.getElementById('kpMood');
    chip.textContent=k.m;chip.style.background='var(--'+k.m+')';chip.style.color='var(--cream)';
    document.getElementById('kpAbout').innerHTML='<span class="serif">'+k.a+'</span>';
    var img=document.getElementById('kpImg');img.src=imSrc('kit-'+k.m)||'';img.alt=k.n;
    var rt=document.getElementById('kpRingThumb');rt.src=imSrc(k.rimg)||'';
    document.getElementById('kpRingName').textContent=k.ring;
    var ot=document.getElementById('kpOilThumb');ot.src=imSrc(k.oimg)||'';
    document.getElementById('kpOilName').textContent=k.oil;
    var bt=document.getElementById('kpBayThumb');
    if(bt){var bslug=k.oimg.slice(3);bt.src=imSrc('ib-'+bslug)||imSrc('im-bay')||''}
    var cart=document.getElementById('kpCart');
    cart.onclick=function(){var ss=document.getElementById('kpScentSel'),ps=document.getElementById('kpPodSel');var sc=(ss&&ss.value)||(window.__KITANCHOR||{})[k.n]||'lavender';var pod=(ps&&ps.value)||'black';quickAdd('refresh kit \u00b7 '+sc+' \u00b7 '+pod,esKitPrice(sc,pod));};
  }
  (function(){
    var shelf=document.getElementById('kpShelf');if(!shelf)return;
    KITSP.forEach(function(k,i){
      var b=document.createElement('button');b.className='chip2';
      b.innerHTML='<span class="d" style="background:var(--'+k.m+')"></span>'+k.n;
      b.onclick=function(){kitPdp.i=i;renderKitPdp();kpToggle()};
      shelf.appendChild(b);
    });
  })();
  function openOilPdp(i){oilPdp.scent=i;renderOilPdp();go('oilpdp')}
  function opPick(d){oilPdp.deliv=d;renderOilPdp()}
  function renderOilPdp(){
    var s=SCENTS[oilPdp.scent];if(!s)return;
    document.querySelectorAll('#opShelf .chip2[data-i]').forEach(function(c){c.setAttribute('aria-pressed',+c.getAttribute('data-i')===oilPdp.scent?'true':'false')});
    var _op=esOilPrice(s.n),_ops=Math.round(_op*0.9*100)/100;
    var _r1=document.querySelector('#opDeliv .sub-row[data-deliv="one"] .save');if(_r1)_r1.textContent='$'+_op.toFixed(2);
    var _r2=document.querySelector('#opDeliv .sub-row[data-deliv="sub"] .save');if(_r2)_r2.textContent='$'+_ops.toFixed(2)+' \u00b7 save 10%';
    var slug=s.img.slice(3);
    document.getElementById('opCrumb').textContent=s.n;
    document.getElementById('opTitle').textContent=s.n;
    var osn=document.getElementById('opScentName');if(osn){osn.textContent=s.n}
    var osd=document.getElementById('opScentDot');if(osd){osd.style.background=(typeof SCOL!=='undefined'&&SCOL[s.n])||'var('+s.c+')'}
    var img=document.getElementById('opImg');
    img.src=imSrc('ob-'+slug)||imSrc(s.img)||'';img.alt=s.n+' essential oil bottle';
    var chip=document.getElementById('opMood');
    chip.textContent=s.mood;chip.style.background='var('+s.c+')';chip.style.color='var(--cream)';
    document.getElementById('opAbout').innerHTML='<span class="serif">'+(s.a||'')+'</span>'
      +(s.use?'<div class="pdp-use"><b>often used for</b> \u2014 '+s.use+'</div>':'')
      +(s.ing?'<div class="pdp-ing"><b>ingredients</b> \u2014 '+s.ing+'</div>':'');
    document.querySelectorAll('#opDeliv .sub-row').forEach(function(r){r.setAttribute('aria-current',r.getAttribute('data-deliv')===oilPdp.deliv?'true':'false')});
    var rt=document.getElementById('opRingThumb');if(rt){var ru=imSrc(s.img);if(ru)rt.src=ru}
    var total=(oilPdp.deliv==='sub'?_ops:_op)+(document.getElementById('opAddRing').checked?21.99:0)+(document.getElementById('opAddTop').checked?9.99:0);
    var btn=document.getElementById('opCart');
    btn.textContent='add to cart \u00b7 $'+total.toFixed(2);
    btn.onclick=function(){
      quickAdd(s.n+' oil 5 mL'+(oilPdp.deliv==='sub'?' (subscribed)':''),oilPdp.deliv==='sub'?_ops:_op);
      if(document.getElementById('opAddRing').checked){quickAdd(s.n+' ring 5-pack',21.99)}
      if(document.getElementById('opAddTop').checked){quickAdd('bottle-top soaking bay',9.99)}
      cartDrawer(true);
    };
  }

  function goProducts(anchor){go('products');if(anchor){setTimeout(function(){var el=document.getElementById(anchor);if(el){el.scrollIntoView({behavior:'smooth'})}},60)}}
  function goLearn(anchor){go('learn');if(anchor){setTimeout(function(){var el=document.getElementById(anchor);if(el){el.scrollIntoView({behavior:'smooth'})}},60)}}

  function goSubscribe(){go('subscribe')}   /* Oct 14 (#9): the homepage club section became Top Bundles */
  function goHub(key){
    if(!MOODS[key]){return}
    currentHub=key;
    var m=MOODS[key];
    var hero=document.getElementById('hubHero');
    var wide=imSrc('bhw-'+key);
    if(wide){hero.classList.add('hub-hero-wide');hero.style.background='var('+m.c+') url("'+wide+'") no-repeat center right / cover'}
    else{hero.classList.remove('hub-hero-wide');hero.style.background='var('+m.c+')'}
    hero.classList.remove('hub-ink');
    var i=ARC.indexOf(key), prev=ARC[(i+ARC.length-1)%ARC.length], next=ARC[(i+1)%ARC.length];
    document.getElementById('hubCrumbs').innerHTML='home / shop by mood / <span class="here">'+key+'</span> &nbsp;·&nbsp; neighbors: '+prev+' · '+next;
    document.getElementById('hubTitle').textContent=key;
    document.getElementById('hubSub').textContent=m.sub;
    document.getElementById('hubCta').textContent='meet '+m.routine.name;
    var R2={refresh:{b:'start before the day does',p:'clip in with your first coffee. slow breaths through the nose; cup your palm over the ring to turn it up.'},
      focus:{b:'clip in at the top of the block',p:'put it on as you sit down, not when you start to drift. slow nose breaths bring it back.'},
      breathe:{b:'get ahead of the stuffy',p:'wear it before the crowded room, the flight, the run. long, low breaths through the nose.'},
      relief:{b:'at the first wave, not the peak',p:'clip in the moment it starts. slow breaths through the nose; palm over the ring to strengthen it.'},
      relax:{b:'when you walk in the door',p:'shoes off, ring in. three slow breaths through the nose to mark the switch.'},
      sleep:{b:'twenty minutes before lights out',p:'clip in as you wind down, not once you are frustrated. slow nose breaths, longer exhale.'}};
    var r2=R2[key];
    if(r2){var b2=document.getElementById('hubStep2B'),p2=document.getElementById('hubStep2P');
      if(b2){b2.textContent=r2.b} if(p2){p2.textContent=r2.p}}
    var KSC={refresh:'orange',focus:'energy',breathe:'peppermint',relief:'nausea',relax:'stress',sleep:'rest-easy'};
    var s2i=document.getElementById('hubStep2Img');
    if(s2i){var bs=imSrc('bh-'+key);if(bs){s2i.src=bs;s2i.alt=key+' botanicals'}}
    var s3i=document.getElementById('hubStep3Img');
    if(s3i){s3i.src=imSrc('ib-'+KSC[key])||imSrc('im-bay')||''}
    var art=imSrc(m.art), ai=document.getElementById('hubArtImg'), ag=document.getElementById('hubArtGap');
    if(wide){ai.hidden=true;ag.hidden=true}
    else if(art){ai.src=art;ai.alt=key+' scent hero';ai.hidden=false;ag.hidden=true}else{ai.hidden=true;ag.hidden=false}
    var sc=document.getElementById('hubScents');
    sc.innerHTML='';
    SCENTS.forEach(function(s,idx){
      if((s.moods||[s.mood]).indexOf(key)===-1){return}
      var about=s.a||('part of the '+key+' shelf.');
      var col=SCOL[s.n]||'#999999';
      var card=document.createElement('div');
      card.className='ing';
      var thumb=imSrc('scw-'+s.img.slice(3))||imSrc(s.img);card.innerHTML=(thumb?'<div class="ing-imgw" style="background:'+(SEDGE[s.img]||col)+'" onclick="openScentPdp('+idx+')"><img loading="lazy" decoding="async" src="'+thumb+'" alt="'+s.n+'"></div>':'')+'<div class="ing-body"><b style="cursor:pointer" onclick="openScentPdp('+idx+')">'+s.n+'</b><p>'+about+'</p>'
        +'<div class="ing-buy"><select aria-label="'+s.n+' option"><option data-p="21.99">ring 5-pack · $21.99</option><option data-p="15.99">ring 3-pack · $15.99</option><option data-p="7.99">single ring · $7.99</option>'
        +(s.g!=='seasonal'&&s.n!=='create it'?'<option data-p="14.99">oil 5 mL · $14.99</option>':'')
        +'</select><button class="quick-add" onclick="ingAdd(this,\''+s.n+'\')">add</button></div></div>';
      sc.appendChild(card);
    });
        var HPACK={
      refresh:{n:'citrus 5-pack',t:'the citrus 5-pack',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/7161ecblxgL._AC_SL1500.jpg?v=1757554925',copy:'the curated shortcut: five citrus rings, the whole bright end of the shelf in one pack.'},
      focus:{n:'focus bundle, concentration collection',t:'the focus bundle',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/5-Focus-front-26.jpg?v=1786619521',copy:'the curated shortcut: five rings picked for lock-in, boxed as one.'},
      breathe:{n:'respiratory 5-pack',t:'the respiratory 5-pack',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/71XpC5FMFLL._AC_SL1500.jpg?v=1757555014',copy:'the curated shortcut: five clear-airway blends in one pack.'},
      relief:{n:'migraine bundle, head and sinus support',t:'the migraine bundle',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/5-Migraine-front-26.jpg?v=1786618624',copy:'the curated shortcut: five head-and-sinus blends, boxed as one.'},
      relax:{n:'calming blends 5-pack',t:'the calming blends 5-pack',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/71iw46nYJyL._AC_SL1500_a97dc8b5-ea48-4387-809f-a6022267e8f0.jpg?v=1757554760',copy:'the curated shortcut: five calming blends in one pack.'},
      sleep:{n:'sleep bundle, wind-down collection',t:'the sleep bundle',img:'https://cdn.shopify.com/s/files/1/0018/1465/9187/files/5-Sleep-front-26.jpg?v=1786617111',copy:'the curated shortcut: five wind-down blends, boxed as one.'}};
    var hp=HPACK[key];
    if(hp){
      var pc=document.createElement('div');pc.className='ing';
      pc.innerHTML='<div class="ing-imgw" style="background:var(--white)"><img loading="lazy" decoding="async" src="'+hp.img+'" alt="'+hp.t+'" style="object-fit:contain"></div>'
        +'<div class="ing-body"><b>'+hp.t+'</b><p>'+hp.copy+'</p>'
        +'<div class="ing-buy"><button class="quick-add" onclick="quickAdd(\''+hp.n+'\',21.99)">add the pack · $21.99</button></div></div>';
      sc.appendChild(pc);
    }
    document.getElementById('hubSteps').style.setProperty('--hub-deep',DEEP[m.c]||'#3A2568');
    document.getElementById('hubRoutinePill').textContent=m.routine.name;
    document.getElementById('hubRoutinePill').style.background='var('+m.c+')';
    document.getElementById('hubRoutinePill').style.color='var(--cream)';
    document.getElementById('hubRoutineHead').textContent=m.routine.head;
    document.getElementById('hubRoutinePrice').textContent='$28.99';
    document.getElementById('hubRoutineCompare').textContent='$37.97 as separates';
    var rb2=document.getElementById('hubRoutineBtn');
    rb2.textContent='add '+m.routine.name+' · $28.99';
    rb2.onclick=function(){quickAdd(m.routine.name,28.99)};
    document.getElementById('hubRoutine').style.borderColor='var('+m.c+')';
    var ri=document.getElementById('hubRoutineImgs');
    ri.innerHTML='';
    m.routine.items.forEach(function(it,k){
      var iid=it[1];
      if(iid==='im-bay'){var KSC2={refresh:'orange',focus:'energy',breathe:'peppermint',relief:'nausea',relax:'stress',sleep:'rest-easy'};iid='ib-'+KSC2[key]}
      if(iid&&iid.indexOf('sc-')===0)iid='scw-'+iid.slice(3);
      var src=iid?(imSrc(iid)||imSrc(it[1])):null;
      var d=document.createElement('div');
      d.innerHTML='<div class="ri">'+(src?'<img loading="lazy" decoding="async" src="'+src+'" alt="'+it[0]+'">':'<div class="ph-gap" style="min-height:100%;border-radius:10px"><svg class="petal" width="26" height="26" aria-hidden="true"><use href="#petal" width="26" height="26"/></svg></div>')
        +(k<2?'<span class="plus" style="background:var('+m.c+')">+</span>':'')+'</div><div class="cap">'+it[0]+'</div>';
      ri.appendChild(d);
    });
    document.getElementById('hubAdjHead').textContent='not sure it\'s '+key+' you need?';
    var adj=document.getElementById('hubAdjacent');
    adj.innerHTML='';
    [prev,next].forEach(function(n){
      var mm=MOODS[n];
      var b=document.createElement('button');
      b.className='adj-tile';
      b.style.background='var('+mm.c+')';
      b.onclick=function(){goHub(n)};
      var au=imSrc('bhw-'+n);
      b.innerHTML=(au?'<img class="adj-bg" src="'+au+'" alt="" loading="lazy" decoding="async">':'')+'<span class="mn">'+n+'</span><span class="mw">'+MOODW[n]+'</span>';
      adj.appendChild(b);
    });
    var q=document.createElement('div');
    q.className='adj-quiz';
    q.innerHTML='<b>or let your nose decide.</b>every scent, its own color, one page.<button class="quiz-cta" onclick="go(\'scents\')">browse every scent</button>';
    adj.appendChild(q);
    go('hub');
  }

  /* duplicate the rainbow track for a seamless loop */
  (function(){
    var t=document.getElementById('rbTrack');
    if(t){t.innerHTML=t.innerHTML+t.innerHTML}
  })();

  /* hero slider */
  var slideIdx=0, slideTimer=null;
  var reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function slideTo(i){
    var slides=document.querySelectorAll('#heroSlider .slide');
    var dots=document.querySelectorAll('#heroSlider .slider-nav button');
    slideIdx=(i+slides.length)%slides.length;
    slides.forEach(function(s,k){s.classList.toggle('on',k===slideIdx)});
    dots.forEach(function(d,k){d.setAttribute('aria-current',k===slideIdx?'true':'false')});
    var sl=document.getElementById('heroSlider');
    sl.classList.toggle('nav-light',slides[slideIdx].classList.contains('slide-finder'));
    restartSlideTimer();
  }
  function slideStep(d){slideTo(slideIdx+d)}
  function restartSlideTimer(){
    clearInterval(slideTimer);
    if(!reduceMotion){if(!(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)){slideTimer=setInterval(function(){slideTo(slideIdx+1)},slideIdx===0?11000:6500)}}
  }
  restartSlideTimer();
  var _hs=document.getElementById('heroSlider');
  if(_hs){_hs.addEventListener('mouseenter',function(){clearInterval(slideTimer)});_hs.addEventListener('mouseleave',restartSlideTimer)}
  /* centre the site map's root; re-run on resize and when the tab opens */
  function centerMap(){
    var sc=document.querySelector('.oc-scroll'), r=document.querySelector('.nd.root');
    if(sc&&r&&sc.clientWidth>0){var rb=r.getBoundingClientRect(),sb=sc.getBoundingClientRect();sc.scrollLeft+=(rb.left+rb.width/2)-(sb.left+sb.width/2)}
  }
  centerMap();
  window.addEventListener('resize',centerMap);
